const WAITER_APP_PATTERN = /^\/[^/]+\/(garcom|estacao)/;

const unauthorized = (api) => {
    api.interceptors.request.use((config) => config);

    api.interceptors.response.use((response) => response,
        (error) => {
            if (error.response.status === 401) {
                const isWaiterRoute = WAITER_APP_PATTERN.test(window.location.pathname);
                const hasWaiterToken = !!sessionStorage.getItem('otp_token');

                if (isWaiterRoute && hasWaiterToken) {
                    sessionStorage.removeItem('otp_token');
                    sessionStorage.removeItem('otp_user');
                    window.location.href = '/acesso';
                } else {
                    localStorage.removeItem("token");
                    window.dispatchEvent(new Event('auth-token-removed'));
                }
            };

            return Promise.reject(error);
        });
};

export default unauthorized;